module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAAOwgAADsIBFShKgAAAABh0RVh0U29mdHdhcmUAcGFpbnQubmV0IDQuMC45bDN+TgAAAJVJREFUOE+1lDEOgCAMRXsBJhdWr+AVGD0UR8cWNKHwIQbr8Ia+8BtIq5RSMgXKL0BZQ5Ecs904dKYGSoHDngnM2SDOo4yAZaS9ajDigNlOlJuhBojupqrIAj9zROjyqigDQMEZalBtQ5kkCs3YVA9V/NDQ9slZWA4lC+u1yZKXtgki3i32AwfsPr0aDtv8HFaBcp1EFxrz6G7OzW+3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doc_icons/procedure_green_old.png
// module id = tByo
// module chunks = 1